import React from 'react';
import { Col, Row } from 'reactstrap';
import { SurveyButton } from '../../../../components/SurveyButton';
import { SurveyQuestionField } from '../../../../entities/SurveyQuestionField';
import { SurveyQuestionFieldAnswer } from '../../../../entities/SurveyQuestionFieldAnswer';

interface PropTypes {
  field: SurveyQuestionField;
  fieldAnswer: SurveyQuestionFieldAnswer;
  onChangeAnswer: (fieldId: number, value: string) => void;
}

export function BooleanField({
  field,
  fieldAnswer,
  onChangeAnswer,
}: PropTypes) {
  return (
    <Row className='mt-4 align-items-center'>
      {field.name && (
        <Col xs='2'>
          <b>{field.name}</b>
        </Col>
      )}
      <Col xs='10' className='d-flex gap-3'>
        <SurveyButton
          active={fieldAnswer.value === 'true'}
          onClick={() => onChangeAnswer(field.id, 'true')}
        >
          Yes
        </SurveyButton>
        <SurveyButton
          active={fieldAnswer.value === 'false'}
          onClick={() => onChangeAnswer(field.id, 'false')}
        >
          No
        </SurveyButton>
      </Col>
    </Row>
  );
}
